// Hex values mirror the Tailwind palette (blue-500, emerald-500, amber-500, violet-500,
// rose-500, cyan-500, orange-500, green-600, indigo-500, pink-500).
export const SERIES_COLORS = [
  '#3b82f6', // blue-500
  '#10b981', // emerald-500
  '#f59e0b', // amber-500
  '#8b5cf6', // violet-500
  '#f43f5e', // rose-500
  '#06b6d4', // cyan-500
  '#f97316', // orange-500
  '#16a34a', // green-600
  '#6366f1', // indigo-500
  '#ec4899', // pink-500
];

export interface AuditFilters {
  groupBy: 'username' | 'action';
  deselectedUsers: string[];
  deselectedActions: string[];
}

export const DEFAULT_AUDIT_FILTERS: AuditFilters = {
  groupBy: 'username',
  deselectedUsers: [],
  deselectedActions: [],
};
